export default __webpack_public_path__ + "static/media/Screenshot_3.1bd1c4c0.png";